import { AfterViewInit, Directive, ElementRef, HostListener, Input, OnDestroy } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Subscription } from 'rxjs';

import { TranslateService } from '__services';

@Directive({
  selector: '[formFieldError]',
  // standalone: true,
})
export class FieldErrorsDirective implements AfterViewInit, OnDestroy {
  @Input('formFieldError') errorCustomMessages:
    | { [key: string]: string }
    | string = {};
  private errorClass = 'form-field-error-message';
  private formFieldClass = 'form-field';
  private errorDefaultMessages: { [key: string]: string } = {};
  private statusChangesSubscription: Subscription | undefined = undefined;

  constructor(
    private el: ElementRef,
    private control: NgControl,
    private translateService: TranslateService,
  ) {}

  ngOnInit() {
    setTimeout(() => {
      this.errorDefaultMessages = {
        required: this.translateService.translate('You must enter a value'),
        email: this.translateService.translate('Invalid email address'),
        pattern: this.translateService.translate('Invalid input'),
        password_unmatch: this.translateService.translate('Confirm passwords does not match'),
        greaterThanZero: this.translateService.translate('The value must be greater than 0'),
      };
    }, 500);
  }

  ngAfterViewInit() {
    this.statusChangesSubscription = this.control.statusChanges?.subscribe(status => {
      this.updateErrorMessage();
    });
  }

  @HostListener('ngModelChange')
  onInputChange() {
    this.updateErrorMessage();
  }

  @HostListener('blur')
  onBlur() {
    this.updateErrorMessage();
  }

  @HostListener('ionBlur') 
  onIonBlur() {
    console.log('ionBlur');
    this.updateErrorMessage();
  }

  ngOnDestroy() {
    this.statusChangesSubscription?.unsubscribe();
  }

  private updateErrorMessage() {
    const el_root = this.el.nativeElement.closest(`.${this.formFieldClass}`);
    if(!el_root) return;
    const el_error = el_root.querySelector(`.${this.errorClass}`);
    if (this.control.invalid) {
      const errorMessage = this.getErrorMessage();
      if (el_error) {
        el_error.textContent = errorMessage;
      } else {
        const div = document.createElement('div');
        div.classList.add(this.errorClass);
        div.textContent = errorMessage;
        el_root.appendChild(div);
      }
    } else {
      if (el_error) {
        el_error.textContent = '';
      }
    }
  }

  private getErrorMessage(): string {
    const errors = this.control.errors;
    let errorMessages = { ...this.errorDefaultMessages };
    if (this.errorCustomMessages) {
      if (typeof this.errorCustomMessages === 'string') {
        const keysDefault = Object.keys(errorMessages);
        for (let key of keysDefault) {
          errorMessages[key] = this.errorCustomMessages;
        }
      }
      if (typeof this.errorCustomMessages === 'object') {
        errorMessages = { ...errorMessages, ...this.errorCustomMessages };
      }
    }
    if (errors) {
      const keys = Object.keys(errors);
      for (let key of keys) {
        if (errorMessages[key] && errors[key]) {
          return errorMessages[key];
        }
      }
    }
    return '';
  }
}
